// extracted by mini-css-extract-plugin
export default {"switch":"style_switch__JTm10","thumb":"style_thumb__aBmbB","checked":"style_checked__hh5JN","disabled":"style_disabled__8u711"};